<div *ngIf="!termsAndCondAccepted"
     class="banner"
     id="banner">
    <div class="text"> We've updated our RewardShip Program
        <span (click)="openTermsConditionsDialog($event)"
              class="text-link">Terms and Conditions</span>, effective
        October 23, 2023. By continuing, you agree to the updated terms.
    </div>
    <button (click)="acceptTermsConditions()"
            mat-raised-button>Continue<span class="material-symbols-outlined">chevron_right</span>
    </button>
</div>
<div class="white-content-page content-disabled">
    <div class="content-layout">
        <div class="dw-rewardship">
            <div class="introduction">
                <div class="message">
                    <div class="title">RewardShip</div>
                    <p class="description">
                        As a Parcel Pro<sup>®</sup> customer, you get the benefit of earning points every time you ship
                        UPS<sup>®</sup> Air
                        services. Get rewarded and redeem your points towards a future shipment in a few easy steps.
                    </p>
                </div>
                <div class="image">
                    <img alt="Ship More, Earn More"
                         src="assets/images/peak-season-website-reap-the-rewards-graphic.png">
                </div>
            </div>

            <ul class="features">
                <li class="feature">
                    <div class="feature-logo">
                        <img alt="Ship More, Earn More"
                             src="assets/images/flightsmode.svg">
                    </div>
                    <div class="feature-content">
                        <div class="feature-title">Ship More, Earn More</div>
                        <div class="feature-description">Earn 1 RewardShip point for every $40 you spend on eligible
                            UPS<sup>®</sup>
                            Air services on the Parcel Pro platform
                        </div>
                    </div>
                </li>
                <li class="feature">
                    <div class="feature-logo">
                        <img alt="How it Works"
                             src="assets/images/contact_support.svg">
                    </div>
                    <div class="feature-content">
                        <div class="feature-title">How it Works</div>
                        <div class="feature-description">Ship a package with a total package value of $300 or more via
                            UPS Next Day
                            Air<sup>®</sup>, UPS Next Day Air Saver<sup>®</sup>, or UPS 2nd Day Air<sup>®</sup>
                        </div>
                    </div>
                </li>
                <li class="feature">
                    <div class="feature-logo">
                        <img alt="Pay With Points"
                             src="assets/images/attach_money.svg">
                    </div>
                    <div class="feature-content">
                        <div class="feature-title">Pay With Points</div>
                        <div class="feature-description">
                            Save time by enabling points to be auto-redeemed or by selecting any outstanding invoice to
                            redeem a portion or all points
                        </div>
                    </div>
                </li>
            </ul>

            <!-- DW-53: Manual Redeem -->
            <div class="tiles">
                <div class="tile redeem-card redeem-card-a">
                    <div class="inner-card">
                        <div class="credit-text"> Available Points:</div>
                        <div class="redeem-points"> {{ availablePoints | number: '0.0-2' }}</div>
                        <button (click)="redeemConfirmation()"
                                [disabled]="availablePoints <= 0 || IsAutoRedeemToggled || noAvailableInvoicesToRedeem"
                                mat-raised-button>
                            <span class="button-label">
                                <span>Redeem</span>
                                <mat-icon>chevron_right</mat-icon>
                            </span>
                            <div *ngIf="IsAutoRedeemToggled"
                                 class="help-container">
                                <img alt="help"
                                     class="help-icon"
                                     src="../../../../assets/icons/help_icon2.svg">
                                <div class="help-popup-message-bubble">
                                    <p> Manual redemption is disabled while auto-redeem is enabled. Please turn off
                                        auto-redeem to enable manual redemption. </p>
                                    <div *ngIf="IsAutoRedeemToggled"
                                         class="triangleDown"></div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

                <!-- DW-66: Auto-Redeem -->
                <div class="tile auto-redeem-card">
                    <div class="auto-redeem-headline"> Auto-Redeem</div>
                    <div class="auto-redeem-text"> Elect for available points to be automatically applied as a credit on
                        future invoices
                    </div>
                    <div class="auto-redeem-action">
                        <mat-slide-toggle (change)="toggleAutoRedeem()"
                                          [(ngModel)]="IsAutoRedeemToggled"
                                          [checked]="IsAutoRedeemToggled"
                                          class="auto-redeem-toggle"></mat-slide-toggle>
                    </div>
                </div>

                <ng-container *ngTemplateOutlet="pointsEarnedCard"></ng-container>
                <ng-container *ngTemplateOutlet="pointsRedeemedCard"></ng-container>
            </div>

            <!-- <div class="attached-tiles-wrapper">
                <div class="attached-tiles">
                    <ng-container *ngTemplateOutlet="pointsEarnedCard"></ng-container>
                    <ng-container *ngTemplateOutlet="pointsRedeemedCard"></ng-container>
                </div>
            </div> -->

            <div class="grid">
                <div class="headline">
                    <div class="headline-text">Invoice History</div>
                    <div class="key-key"></div>
                </div>
            </div>
        </div>

        <div class="dw-rewardship-invoice-table">
            <div class="table-actions-wrapper">
                <div class="invoice-table-actions"
                     id="invoice_table_actions">
                    <form [formGroup]="categoryFormGroup"
                          class="category-form left-action">
                        <mat-form-field subscriptSizing="dynamic">
                            <mat-label>Select Category</mat-label>
                            <mat-select formControlName="selectCategory">
                                <mat-option *ngFor="let category of searchCategory"
                                            [value]="category">
                                    {{ category }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>

                    <form (ngSubmit)="onSearchSubmit($event, searchFormGroup.value)"
                          *ngIf="!isDateSearch"
                          [formGroup]="searchFormGroup"
                          class="search-table-form left-action">
                        <mat-form-field subscriptSizing="dynamic">
                            <mat-label>Search Table</mat-label>
                            <input (keypress)="onKeypressEvent($event, categoryFormGroup.value)"
                                   formControlName="keyword"
                                   matInput
                                   type="text">
                            <mat-icon matPrefix>search</mat-icon>
                        </mat-form-field>
                    </form>

                    <form *ngIf="isDateSearch"
                          [formGroup]="customDateRangeFormGroup"
                          class="date-form left-action">
                        <mat-form-field subscriptSizing="dynamic">
                            <mat-label>{{ categoryFormGroup.controls.selectCategory.value.toString() }}</mat-label>
                            <input matInput
                                   [matDatepicker]="startPicker"
                                   (keypress)="inputDateValidations($event)"
                                   formControlName="startDate"
                                   placeholder={{categoryFormGroup.controls.selectCategory.value.toString()}}>
                            <mat-datepicker-toggle [for]="startPicker"
                                                   matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>
                    </form>

                    <button (click)="onSearchSubmit($event, searchFormGroup.value)"
                            class="search-button"
                            mat-raised-button>
                        <span class="button-label">
                            <span>Search</span>
                            <mat-icon>chevron_right</mat-icon>
                        </span>
                    </button>

                    <div class="right-actions">
                        <button (click)="exportExcel()"
                                class="download-data-button right-action"
                                mat-flat-button>
                            <svg fill="none"
                                 height="40"
                                 viewBox="0 0 40 40"
                                 width="40"
                                 xmlns="http://www.w3.org/2000/svg">
                                <mask height="24"
                                      id="mask0_2768_10661"
                                      maskUnits="userSpaceOnUse"
                                      style="mask-type:alpha"
                                      width="24"
                                      x="8"
                                      y="8">
                                    <rect fill="#D9D9D9"
                                          height="24"
                                          width="24"
                                          x="8"
                                          y="8"/>
                                </mask>
                                <g mask="url(#mask0_2768_10661)">
                                    <path d="M20 23.4494C19.8507 23.4494 19.7078 23.4235 19.5712 23.3719C19.4346 23.3203 19.3103 23.2385 19.1984 23.1265L15.5087 19.4369C15.2848 19.2129 15.176 18.9477 15.1823 18.6412C15.1887 18.3347 15.2975 18.0695 15.5087 17.8456C15.7366 17.6177 16.006 17.5005 16.3168 17.4942C16.6277 17.4878 16.8971 17.5986 17.125 17.8265L18.8625 19.564V12.9342C18.8625 12.6149 18.9723 12.3455 19.1918 12.126C19.4114 11.9064 19.6808 11.7966 20 11.7966C20.3192 11.7966 20.5886 11.9064 20.8081 12.126C21.0277 12.3455 21.1375 12.6149 21.1375 12.9342V19.564L22.875 17.8265C23.0989 17.5986 23.3663 17.4869 23.6772 17.4912C23.988 17.4956 24.2574 17.6117 24.4853 17.8396C24.7005 18.0675 24.8113 18.3337 24.8177 18.6382C24.824 18.9427 24.7132 19.209 24.4853 19.4369L20.8016 23.1265C20.6897 23.2385 20.5654 23.3203 20.4288 23.3719C20.2922 23.4235 20.1493 23.4494 20 23.4494ZM14.0717 28.2032C13.442 28.2032 12.9054 27.9814 12.4619 27.538C12.0185 27.0945 11.7967 26.5579 11.7967 25.9282V24.0657C11.7967 23.7465 11.9065 23.4771 12.1261 23.2575C12.3456 23.0379 12.615 22.9282 12.9342 22.9282C13.2534 22.9282 13.5228 23.0379 13.7424 23.2575C13.962 23.4771 14.0717 23.7465 14.0717 24.0657V25.9282H25.9282V24.0657C25.9282 23.7465 26.038 23.4771 26.2576 23.2575C26.4772 23.0379 26.7465 22.9282 27.0657 22.9282C27.385 22.9282 27.6544 23.0379 27.8739 23.2575C28.0935 23.4771 28.2033 23.7465 28.2033 24.0657V25.9282C28.2033 26.5579 27.9815 27.0945 27.538 27.538C27.0946 27.9814 26.558 28.2032 25.9282 28.2032H14.0717Z"
                                          fill="#1C1B1F"/>
                                </g>
                            </svg>
                            <span>Download Data</span>
                        </button>

                        <div class="advanced-filter">
                            <button (click)="onClickAdvancedFilter(false)"
                                    [class.active]="showAdvancedFilterPanel"
                                    class="right-action"
                                    id="advanced_filter_button"
                                    mat-flat-button>
                                <svg fill="none"
                                     height="40"
                                     viewBox="0 0 40 40"
                                     width="40"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <mask height="24"
                                          id="mask0_3342_9402"
                                          maskUnits="userSpaceOnUse"
                                          style="mask-type:alpha"
                                          width="24"
                                          x="0"
                                          y="0">
                                        <rect fill="#D9D9D9"
                                              height="24"
                                              width="24"/>
                                    </mask>
                                    <g mask="url(#mask0_3342_9402)"
                                       transform="translate(8, 8)">
                                        <path d="M11.0359 20C10.7147 20 10.4457 19.8898 10.229 19.6694C10.0119 19.4494 9.90341 19.1764 9.90341 18.8503V13.0275L4.24 5.68807C3.96701 5.34557 3.92691 4.97859 4.1197 4.58716C4.31249 4.19572 4.62577 4 5.05955 4H18.9405C19.3742 4 19.6875 4.19572 19.8803 4.58716C20.0731 4.97859 20.033 5.34557 19.76 5.68807L14.0966 13.0275V18.8991C14.0966 19.2091 13.9921 19.47 13.7831 19.6818C13.5745 19.8939 13.3175 20 13.0121 20H11.0359ZM12 12.7093L17.3256 5.85952H6.67436L12 12.7093Z"
                                              fill="#121212"/>
                                    </g>
                                </svg>
                                <span>Advanced Filter</span>
                            </button>

                            <div [class.hide]="!showAdvancedFilterPanel"
                                 class="advanced-filter-panel">
                                <div class="top-actions">
                                    <button (click)="onClickAdvancedFilter(true)" class="close-icon" tabindex="-1">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                <upsc-dw-rewardship-advanced-filter></upsc-dw-rewardship-advanced-filter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-filters-wrapper"
                 id="table_filters_wrapper">
                <div class="invoice-table-filters" id="invoice_table_filters">
                    <upsc-dw-rewardship-advanced-filter-chips></upsc-dw-rewardship-advanced-filter-chips>
                    @if (shouldShowChipResetButton) {
                        <a (click)="resetAdvancedFilter($event)" class="reset-all-link">
                            {{ 'Reset All'|translate }}
                        </a>
                    }
                </div>
            </div>

            <div class="table-container">
                <div class="table-wrapper">
                    <table class="ups-table">
                        <thead>
                        <tr>
                            <!-- <th class="all trigger-column"></th> -->
                            <th> <mat-checkbox (change)="updateAllCheckboxes($event)" [checked]="checkAll"></mat-checkbox> </th>
                            <th>Business</th>
                            <th>Invoice Number</th>
                            <th>Invoice Date</th>
                            <th>Due Date</th>
                            <th>Balance</th>
                            <th>Status</th>
                            <th>Earned Points</th>
                            <th>Action</th>
                            <!-- <th class="all"></th> -->
                        </tr>
                        </thead>
                        <tbody #tb>
                        <tr *ngFor="let item of displayedInvoiceLists | paginate:paginate">
                            <!--                    <td class="trigger-cell"></td>-->
                            <td> <mat-checkbox (change)="changeChecks($event, item.invoiceID)" [checked]="item?.isChecked"></mat-checkbox> </td>
                            <td class="show">{{ item?.business }} </td>
                            <td class="pdf_links"> <a (click)="downloadInvoice(item?.invoiceID)" href="javascript:;">{{ item?.invoiceID }}</a> </td>
                            <td>{{ item?.invoiceDate | date : 'MM/dd/yyyy' }}</td>
                            <td>{{ item?.dueDate | date : 'MM/dd/yyyy' }}</td>
                            <td> ${{ item?.balance | number : '1.2-2' }} </td>
                            <td class="status">
                                <div [ngClass]="{'PAID' : 'green-status', 'UNPAID' : 'yellow-status', 'PAST DUE' : 'red-status'}[item?.status]" class="chip">
                                    {{ item?.status }}
                                </div>
                            </td>
                            <td> <span>{{ item?.points ? item?.points.toFixed(2) + ' pts' : '-' }} </span> </td>
                            <td>
                                <div *ngIf="item?.balance > 0 && !item.isDisputed" class="redeem-link">
                                    <ng-container  *ngIf="availablePoints <= 0 || IsAutoRedeemToggled || noAvailableInvoicesToRedeem; else enableRedeemLink">
                                        <!-- Disable redeem link in table -->
                                        <a href="javascript:;" style="text-decoration: none; display: inline-flex; pointer-events: none; color: gray;">
                                            {{ 'Redeem'|translate }}
                                            <span class="material-symbols-outlined">chevron_right</span>
                                        </a>
                                    </ng-container>

                                    <ng-template #enableRedeemLink>
                                        <!-- Enable redeem link in table -->
                                        <a (click)="redeemConfirmation(true, item.invoiceID, item.balance);" href="javascript:;" style="text-decoration: none; display: inline-flex;">
                                            {{ 'Redeem'|translate }}
                                            <span class="material-symbols-outlined">chevron_right</span>
                                        </a>
                                    </ng-template>
                                </div>

                                <div *ngIf="+(item?.balance) === 0 || item.isDisputed">-</div>
                            </td>
                            <!--                    <td class="all"></td>-->
                        </tr>
                        <tr *ngIf="displayedInvoiceLists.length === 0">
                            <td class="text-center" colspan="10">
                                <span style="align-items: center; font-size: 18px;"> {{ 'NoRecordsFound'|translate }} </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <upsc-element-blocker *ngIf="isSearching"></upsc-element-blocker>
        </div>

        <div class="select-all-panel-wrapper">
            <div class="select-all-panel">
                <mat-checkbox (change)="updateAllCheckboxes($event)"
                              [checked]="checkAll"></mat-checkbox>
                <span>Select All</span>
            </div>
        </div>
        <div class="invoices">
            <upsc-invoice-card (downloadInvoiceClicked)="downloadInvoice(invoice?.invoiceID)"
                               (redeemClicked)="redeemConfirmation(true, invoice?.invoiceID, invoice?.balance)"
                               *ngFor="let invoice of displayedInvoiceLists"
                               [item]="invoice"></upsc-invoice-card>
        </div>
        <!-- Replaced new paginator -->
        <div *ngIf="displayedInvoiceLists.length > 0" class="pagination-wrapper">
            <upsc-custom-paginator (data)="paginationChange($event)"
                                   [length]="totalItems"
                                   [pageIndex]="tablePageIndex"
                                   [pageSizeOptions]="[5, 10, 25, 50, 100]"
                                   class="float-right"></upsc-custom-paginator>
        </div>
        <div class="contact">
            <div class="title">
                {{ 'HaveQuestions'|translate }}?
            </div>
            <div class="message">
                {{ 'ContactUsAt'|translate }} <a href="mailto:accounting@parcelpro.com">accounting&#64;parcelpro.com</a>
            </div>
        </div>
        <div class="rules">
            {{ 'ProgramRulesApply.MessagePart1'|translate }} 
            <a (click)="openTermsConditionsDialog($event)" href="javascript:;">{{ 'ProgramRulesApply.Link'|translate }}</a>
            {{ 'ProgramRulesApply.MessagePart2'|translate }}.
        </div>
    </div>
</div>

<ng-template #pointsEarnedCard>
    <div class="tile point-card earned">
        <div class="points-earned-head-layout">
            <div class="icon">
                <span><img alt="downloadImage" class="downloadIcon icon" src="../../../../assets/icons/upsc_digital_wallet_balance.png"></span>
            </div>
            <div class="stats">
                <div [ngClass]="{'green-arrow': redeemPtsVar > 0, 'red-arrow': redeemPtsVar < 0, 'grey-arrow': redeemPtsVar === 0 }" class="arrow">
                    <mat-icon [ngStyle]="{'color': rewardPtsVar > 0 ? 'green' : (rewardPtsVar < 0 ? 'red' : 'grey')}">
                        {{ rewardPtsVar > 0 ? 'trending_up' : (rewardPtsVar < 0 ? 'trending_down' : 'trending_flat') }}
                    </mat-icon>
                </div>
                <div [ngClass]="{'positive-response': rewardPtsVar >= 0, 'negative-response': rewardPtsVar < 0}"
                     class="arrow-response">
                    {{ rewardPtsVar > 0 ? '+' : '' }}{{ rewardPtsVar }}% vs last 30 days
                </div>
            </div>
        </div>
        <div class="earned-points-layout">
            <div class="earned-points">{{ currMonthRewardPts }}</div>
            <div class="earned-points-text">Points earned the last 30 days</div>
        </div>
    </div>
</ng-template>

<ng-template #pointsRedeemedCard>
    <div class="tile point-card redeemed">
        <div class="points-earned-head-layout">
            <div class="icon">
                <span><img alt="downloadImage" class="downloadIcon icon" src="../../../../assets/icons/upsc_digital_wallet_expense.png"></span>
            </div>
            <div class="stats">
                <div [ngClass]="{'green-arrow': redeemPtsVar > 0, 'red-arrow': redeemPtsVar < 0, 'grey-arrow': redeemPtsVar === 0 }" class="arrow">
                    <mat-icon [ngStyle]="{'color': redeemPtsVar > 0 ? 'green' : (redeemPtsVar < 0 ? 'red' : 'grey')}">
                        {{ redeemPtsVar > 0 ? 'trending_up' : (redeemPtsVar < 0 ? 'trending_down' : 'trending_flat') }}
                    </mat-icon>
                </div>
                <div [ngClass]="{'positive-response': rewardPtsVar >= 0, 'negative-response': rewardPtsVar < 0}" class="arrow-response">
                    {{ redeemPtsVar > 0 ? '+' : '' }}{{ redeemPtsVar }}% vs last 30 days
                </div>
            </div>
        </div>
        <div class="earned-points-layout">
            <div class="earned-points">{{ currMonthRedeemPts }}</div>
            <div class="earned-points-text">Points redeemed the last 30 days</div>
        </div>
    </div>
</ng-template>